import {
    ADD_BRANCH_DEVICE_ACTION,
    CLEAR_BRANCH_DEVICE_ACTION,
    DELETE_BRANCH_DEVICE_ACTION,
    FULL_COVERAGE_BRANCH_DEVICE_ACTION,
    MODIFY_BRANCH_DEVICE_ACTION
} from '../../../actionType';

export default function (state=[],action){
    switch (action.type) {
        case ADD_BRANCH_DEVICE_ACTION:
            return [
                ...state,
                {
                    id:action.id,
                    key:action.key,
                    deviceModelId:action.deviceModelId,
                    deviceModel:action.deviceModel,
                    manufacturerId:action.manufacturerId,
                    manufacturerName:action.manufacturerName,
                    supplierId:action.supplierId,
                    supplierName:action.supplierName,
                    supplierTin:action.supplierTin,
                    stock:action.stock,
                    devicePrice:action.devicePrice,
                    quantity:action.quantity,
                    totalAmount:action.totalAmount,
                }
            ];
        case MODIFY_BRANCH_DEVICE_ACTION:
            const deviceGridData = state;
            deviceGridData[action.index] = action.deviceInfo;
            return [
                ...deviceGridData,
            ];
        case DELETE_BRANCH_DEVICE_ACTION:
            state.splice(action.index,1);
            return [...state];
        case CLEAR_BRANCH_DEVICE_ACTION:
            return [];
        case FULL_COVERAGE_BRANCH_DEVICE_ACTION:
            return action.branchDeviceGridData;
        default:
            return state;
    }
}
